namespace TabAurous.Retail {
    export namespace OpenConsignmentOutService {
        export const baseUrl = 'Retail/POSOpenConsignmentOut';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<POSApprovalItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/POSOpenConsignmentOut/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OpenConsignmentOutService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
